import React from "react";
import { Box, Stack } from "@mui/joy";
import type { Training } from "../../../api/training/Training.typed";
import ActionTooltip from "../../common/ActionTooltip";
import DarkTypography from "../../common/DarkTypography";
import IconButtonCTA from "../../common/IconButtonCTA";
import { SOpenProfile } from "../../../styles/StyledMUI";
import { listRowAccentPlainSx } from "../../../styles/globalStyles";

type TrainingIdentityBlockProps = {
  training: Training;
  canOpenProfile: boolean;
  onOpenProfile: () => void;
  fallback: React.ReactNode;
};

export default function TrainingIdentityBlock({
  training,
  canOpenProfile,
  onOpenProfile,
  fallback,
}: TrainingIdentityBlockProps) {
  const customerName =
    [training.FirstName, training.LastName].filter(Boolean).join(" ").trim() || "—";
  const qualificationText = [training.Agency, training.Qualification]
    .filter(Boolean)
    .join(" • ")
    .trim();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        minWidth: 0,
        flex: 1,
      }}
    >
      {canOpenProfile ? (
        <ActionTooltip title="Profil">
          <IconButtonCTA
            ctaVariant="accent"
            aria-label="Profil"
            size="sm"
            variant="plain"
            onClick={onOpenProfile}
            sx={{ ...listRowAccentPlainSx, flexShrink: 0 }}
          >
            <SOpenProfile />
          </IconButtonCTA>
        </ActionTooltip>
      ) : (
        fallback
      )}
      <Stack spacing={0.25} sx={{ minWidth: 0, flex: 1 }}>
        <DarkTypography
          level="title-md"
          colorVariant="primary"
          sx={{
            fontWeight: 700,
            minWidth: 0,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            lineHeight: 1.2,
          }}
        >
          {customerName}
        </DarkTypography>
        {qualificationText ? (
          <DarkTypography
            level="body-xs"
            colorVariant="muted"
            sx={{
              minWidth: 0,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              lineHeight: 1.2,
            }}
          >
            {qualificationText}
          </DarkTypography>
        ) : null}
      </Stack>
    </Box>
  );
}
